module.exports = __webpack_public_path__ + "img/select-remove.4afd3a69.svg";